export const RESULT_FOR = 'result.for';
export const RESULT_PROFILES_TAB_LABEL = 'result.profiles-tab-label';
export const RESULT_POSTS_TAB_LABEL = 'result.posts-tab-label';
